<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/organization-step1')"></span>
    </div>
    <div class="title">待服务房间数目</div>
    <div class="main">
			<div class="item-title">
				<img src="../../assets/img/clean/room/livingroom.svg"> 客厅
      </div>
      <div class="item">
				<div class="option-btn" :class="{ active:  order.data.livingroom=='0'}" @click="orderUpdate('livingroom','0')">0</div>
				<div class="option-btn" :class="{ active:  order.data.livingroom=='1'}" @click="orderUpdate('livingroom','1')">1</div>
				<div class="option-btn" :class="{ active:  order.data.livingroom=='2'}" @click="orderUpdate('livingroom','2')">2</div>
				<div class="option-btn" :class="{ active:  order.data.livingroom=='3'}" @click="orderUpdate('livingroom','3')">3</div>
				<div class="option-btn more" :class="{ active:  order.data.livingroom=='more'}" @click="orderUpdate('livingroom','more')">更多</div>
      </div>

			<div class="item-title">
				<img src="../../assets/img/clean/room/bedroom.svg"> 卧室 / 书房 / 杂物间
      </div>
      <div class="item">
				<div class="option-btn" :class="{ active: order.data.bedroom=='0'}" @click="orderUpdate('bedroom','0')">0</div>
				<div class="option-btn" :class="{ active: order.data.bedroom=='1'}" @click="orderUpdate('bedroom','1')">1</div>
				<div class="option-btn" :class="{ active: order.data.bedroom=='2'}" @click="orderUpdate('bedroom','2')">2</div>
				<div class="option-btn" :class="{ active: order.data.bedroom=='3'}" @click="orderUpdate('bedroom','3')">3</div>
				<div class="option-btn more" :class="{ active: order.data.bedroom=='more'}" @click="orderUpdate('bedroom','more')"> 更多</div>
      </div>

			<div class="item-title">
				<img src="../../assets/img/clean/room/bathroom.svg">浴室
      </div>
      <div class="item">
				<div class="option-btn" :class="{ active:  order.data.bathroom=='0'}" @click="orderUpdate('bathroom','0')">0</div>
				<div class="option-btn" :class="{ active:  order.data.bathroom=='1'}" @click="orderUpdate('bathroom','1')">1</div>
				<div class="option-btn" :class="{ active:  order.data.bathroom=='2'}" @click="orderUpdate('bathroom','2')">2</div>
				<div class="option-btn" :class="{ active:  order.data.bathroom=='3'}" @click="orderUpdate('bathroom','3')">3</div>
				<div class="option-btn more" :class="{ active:  order.data.bathroom=='more'}" @click="orderUpdate('bathroom','more')">更多</div>
      </div>


    </div>


    <div class="btn-box-fix">
      <div class="btn-container">

        <div class="btn" @click="checkSubmit()" :class="{ active: allFilled()}">下一步</div>
      </div>
    </div>
    <img :src="pixelURL('organization','fangjian')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'organization-step2',
  data () {
    return {
      order:{},
    }
  },
  methods: {
    allFilled(){
        if(this.order.data.livingroom && this.order.data.bedroom && this.order.data.bathroom){
            if(this.order.data.bedroom + this.order.data.livingroom > 0 || this.order.data.bedroom=='more' || this.order.data.livingroom=='more'){
              return true;
            }
        }
    },
    checkSubmit(){
      if(this.allFilled()){
        this.submitNext();
      }
      else{
          if(parseInt(this.order.data.bedroom) + parseInt(this.order.data.livingroom) == 0){
            alert("客厅和卧室至少需要选择一间以上")
          }
          else{
            alert('请填写完所有房间数目')
          }
      }
    },

    submitNext(){
      if(this.allFilled()){
            this.orderUpdateAll('/organization-step3');
      }
      else{
          alert('请填写完所有房间数目')
      }
    },


  },
  components: {
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "organization"){
        this.order = localParsed;
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.main{
	margin-top:14px;
}

.multilayer{
	text-align:center;
  margin:20px 0;
  .option-btn{
    border:2px solid #fe9567;
    border-radius:4px;
    min-width:68px;
    padding:0 8px;
    height:34px;
    line-height:34px;
    color:#ff7444;
    display:inline-block;
    margin:0 4px;
    text-align:center;
    background:#fff;
  }

  .option-btn.active{
    border:2px solid #fe9567;
    border-radius:4px;
    width:68px;
    height:34px;
    line-height:34px;
    background-color:#fe9567;
    color:#fff;
    display:inline-block;
    margin:0 4px;
    -webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
    -moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
    box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  }
}

.item-title{
	margin:0 10vw 4px 10vw;
	display: flex;
	justify-content:left;
	align-items:center;
	font-size:1em;
	color:#5A5C68;
	img{
		margin-right:8px;
		width:32px;
	}
}
.item{
	margin:0 9vw 28px 9vw;
  display: flex;
	justify-content:left;
  align-items:center;
}


.option-btn{
	background:#eee;
  border-radius:4px;
  min-width:10vw;
	padding:2px 4px;
  height:28px;
  line-height:28px;
  color:#999;
  display:inline-block;
  margin:0 2vw;
	text-align:center;
	&.more{
		font-size:0.8em;
	}
}

.option-btn.active{
  background-color:#fe9567;
  color:#fff;
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}


.info-box{
	min-height:60px;
	padding-top:13px;
}

.info{
	font-weight:100;
	text-align:center;
	padding-top:4px;
}

.carpetInfo{
	font-weight:100;
	text-align:center;
	padding-top:4px;
  font-size:0.8em;
  margin-bottom:20px;
}

.mgt10{
  margin-top:10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/organization/step2.vue